export default __webpack_public_path__ + "scene5_3_icon853250.png";